import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { Grid } from '@mui/material';
import { positiveAmount } from '../../utils/util';
import { SelectInput, NumberInput } from 'react-admin';
import React from 'react';
import { SUPPORTED_CURRENCIES, CurrencyChoices } from '../Constants';
import {
  areDependentValidationsSatisfied,
  showAmountCurrencyAndCurrencyToProve,
} from '../../utils/CreateReportUtils';
import { createCurrencyChoicesDynamically } from "../../utils/util";
import { isAmountToProveFieldRequired, isAmountToProveMandatory, canFieldBeHidden } from '../../utils/CreateReportUtils';
import {
  requiredValidation,
} from "../../utils/util";
import { useWatch, useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router';
import { extractQueryParamsFromURL } from '../../mappers/Report';
import {padding2,removeNumberArrowsStyle,textColor,width} from '../Styles'

export const CurrencyAndAmountDynamicFields = (props) => {
  const { isMatterShow } = props;
  const values = useWatch();
  const amountCurrencyField = props.currencyField;
  const amountField = props.amountField;
  const amountFieldRequired = amountField?.required
  const form = useFormContext();
  const location = useLocation();
  const showAmount = isAmountToProveFieldRequired(values);

  const amountCurrencyFromUrl = extractQueryParamsFromURL(location?.search, 'amountCurrency');
  const resolvedAmountCurrencyDefault = amountCurrencyFromUrl ?? amountCurrencyField?.defaultValue ?? SUPPORTED_CURRENCIES.POUND;

  const amountToProveFromUrl = extractQueryParamsFromURL(location?.search, 'amountToProve');
  const resolvedAmountToProveDefault = amountToProveFromUrl ? Number(amountToProveFromUrl) : amountField?.defaultValue;

  React.useEffect(() => {//crs-hook
    if(showAmountCurrencyAndCurrencyToProve(values.reportType, values.multiReportType)){
      form.setValue("amountCurrency", resolvedAmountCurrencyDefault);
    } else {
      form.resetField("amountCurrency");
    }

    if(!isMatterShow && showAmountCurrencyAndCurrencyToProve(values.reportType, values.multiReportType) && showAmount){
      form.setValue("amountToProve", resolvedAmountToProveDefault);
    } else {
      form.resetField("amountToProve");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[values.reportType, isMatterShow, props.selectedTemplateId, amountCurrencyField?.defaultValue, amountField?.defaultValue, JSON.stringify(values.multiReportType), showAmount])

  if (
    amountCurrencyField &&
    amountField &&
    amountCurrencyField.dependentOn &&
    amountField.dependentOn &&
    !areDependentValidationsSatisfied(amountField.dependentOn, values) &&
    !areDependentValidationsSatisfied(amountCurrencyField.dependentOn, values)
  )
    return null;

  const currencyChoices =
    amountCurrencyField && amountCurrencyField.possibleValues
      ? createCurrencyChoicesDynamically(amountCurrencyField.possibleValues)
      : CurrencyChoices;

  const isAmountToProveRequired = !!isAmountToProveMandatory(values, amountFieldRequired);
  return (
    showAmountCurrencyAndCurrencyToProve(values.reportType, values.multiReportType) && (
      <React.Fragment>
        <Grid sx={{
          ...(amountCurrencyField && canFieldBeHidden(
            amountCurrencyField.isHidden,
            amountCurrencyField.required,
            amountCurrencyField.defaultValue
          ) ? { display: "none" } : {} )
        }}>
          <ListItem sx={padding2.y}>
            <Grid container alignItems="center">
              <Grid item xs={12} md={4} sx={textColor.gray}>
                {amountCurrencyField ? amountCurrencyField.displayName : 'Amount Currency'}
                {amountCurrencyField?.required && <span style={{...textColor.red, marginLeft: '3px'}}>*</span>}
              </Grid>
              <Grid item xs={12} md={props.isMatterShow ? 8 : 6} lg={props.isMatterShow ? 8 : 5}>
                <SelectInput
                  id="reports-create-amount-currency-select"
                  source="amountCurrency"
                  label={amountCurrencyField ? amountCurrencyField.placeholder : 'Amount Currency'}
                  variant="outlined"
                  size="small"
                  defaultValue={resolvedAmountCurrencyDefault}
                  choices={currencyChoices}
                  validate={amountCurrencyField?.required && requiredValidation}
                  isRequired
                  sx={{ ...width.fluid.w75, marginBottom: "-15px" }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider light />
        </Grid>
        {!props.isMatterShow && isAmountToProveFieldRequired(values) && (
          <React.Fragment>
            <Grid sx={{
              ...(amountField && canFieldBeHidden(
                amountField.isHidden,
                isAmountToProveMandatory(values, amountFieldRequired),
                amountField.defaultValue
              ) ? { display: "none" } : {})
            }}
            >
              <ListItem sx={padding2.y}>
                <Grid container alignItems="center">
                  <Grid item xs={12} md={4} sx={textColor.gray}>
                    {amountField ? amountField.displayName : 'Amount to Prove'}
                    {isAmountToProveMandatory(values, amountFieldRequired) && <span style={{...textColor.red, marginLeft: '3px'}}>*</span>}
                  </Grid>
                  <Grid item xs={12} md={6} lg={5}>
                    <NumberInput
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                      source="amountToProve"
                      label={
                        amountField && amountField.placeholder ?
                          amountField.placeholder :
                          `Amount to Prove${isAmountToProveMandatory(values, amountFieldRequired) ? '' : ' (Optional)'}`
                      }
                      variant="outlined"
                      size="small"
                      onKeyPress={(e) => {
                        //number input dont allow charcaters generally, 'e' was allowed to store big intergers, hence disabling that manually
                        if (e.key === 'e') {
                          e.preventDefault();
                        }
                      }}
                      defaultValue={resolvedAmountToProveDefault}
                      min={0}
                      validate={[isAmountToProveRequired && requiredValidation, positiveAmount]}
                      sx={{ ...removeNumberArrowsStyle, ...width.fluid.w75, marginBottom: "-15px" }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <Divider light />
            </Grid>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  );
};

export default CurrencyAndAmountDynamicFields;